import { BasicDialogProperties } from "../../../../basic/view/dialogs/BasicDialogProperties";

import { AchievementsVO } from "../../../gamevo/AchievementsVO";

export class Poker2PopUpAchievementDialogProperties extends BasicDialogProperties {
    public achievement: AchievementsVO;
    public achievementName: string;
    public achievementRank: number = 0;

    constructor(achievement: AchievementsVO, achievementName: string, achievementRank: number) {
        super();

        this.achievement = achievement;
        this.achievementName = achievementName;
        this.achievementRank = achievementRank;
    }
}
